import React from 'react'

function DatesRentalSelectForm() {
  return (
    <div>DatesRentalSelectForm</div>
  )
}

export default DatesRentalSelectForm